import { IReservation } from './../types/reservationTypes'
import { AlertColor } from '@mui/material/Alert'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '.'

export interface IReservationSlice {
  status: string
  shouldOpen: boolean
  message: string | undefined
  severity: AlertColor | undefined
  reservations: IReservation[]
}

const initialState: IReservationSlice = {
  status: 'idle',
  shouldOpen: false,
  message: undefined,
  severity: undefined,
  reservations: [],
}

export const reservationSlice = createSlice({
  name: 'reservation',
  initialState,
  reducers: {
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.shouldOpen = action.payload
    },
    setReservation: (state, action: PayloadAction<IReservation>) => {
      state.reservations.push(action.payload)
    },
    clearData: () => initialState,
  },
})

export const selectIsLoading = (state: RootState): boolean =>
  state.reservation.status === 'loading'
export const selectShouldOpen = (state: RootState): boolean =>
  state.reservation.shouldOpen
export const selectMessage = (state: RootState): string | undefined =>
  state.reservation.message
export const selectSeverity = (state: RootState): AlertColor | undefined =>
  state.reservation.severity
export const selectReservations = (state: RootState): IReservation[] =>
  state.reservation.reservations

export const { setOpen, clearData, setReservation } = reservationSlice.actions

export default reservationSlice.reducer
